<script>
export default {
    computed: {
        version() {
            return process.env.VUE_APP_VERSION;
        },
        poweredByName() {
            return process.env.VUE_APP_POWERED_BY_NAME;
        },
        poweredByUrl() {
            return process.env.VUE_APP_POWERED_BY_URL;
        },
    },
}
</script>

<template>
    <footer class="footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="text-center text-lg-end ">
                        Powered by
                        <a :href="`${poweredByUrl}`" target="_blank" class="text-reset">{{poweredByName}} {{ new Date().getFullYear()}}</a> <span class="ms-4">Version: {{version}} </span>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
